import { defineMessages } from 'react-intl'

const messages = defineMessages({
  showAllRegions: {
    id: 'FilterContainer.showAllRegions',
    description: 'Texto para el filtro de todas las regiones',
    defaultMessage: 'Comparar con UE27 (2020)'
  },
  showReferenceRegions: {
    id: 'FilterContainer.showReferenceRegions',
    description: 'Texto para el filtro de las regiones de referencia',
    defaultMessage: 'Regiones de referencia'
  },
  showSameCountryRegions: {
    id: 'FilterContainer.showSameCountryRegions',
    description: 'Texto para el filtro de las regiones del mismo país',
    defaultMessage: 'Comparar con país'
  },
  compareWith: {
    id: 'FilterContainer.compareWith',
    description: 'Texto del label para comparar con otra region',
    defaultMessage: 'Comparar con...'
  },
  evolutionSince: {
    id: 'FilterContainer.evolutionSince',
    description: 'Texto del label para seleccionar la evolucion',
    defaultMessage: 'Evolución desde hace...'
  },
  chartType: {
    id: 'FilterContainer.chartType',
    description: 'Texto del label para seleccionar el tipo de gráfico',
    defaultMessage: 'Tipo de gráfico'
  },
  visualizationOptions: {
    id: 'FilterContainer.visualizationOptions',
    description: 'Titulo para la seccion de filtros',
    defaultMessage: 'Opciones de visualización'
  },
  tooltip: {
    id: 'FilterContainer',
    description: 'Texto para el tooltip',
    defaultMessage: 'Ver listado de regiones incluídas'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Filters/FilterContainer/messages.js